import toaster from 'helpers/toaster';
import { dispatchLogoutEvent } from 'helpers/events';
import { notifyWhenReady } from 'helpers/pendingNotification';
import { sessionTerminationMessages } from 'constants/sessionTermination';

const errorHandler = error => {
  if (error.response.status === 401) {
    const terminationMessage = sessionTerminationMessages[error.response.data && error.response.data.Reason];

    if (terminationMessage) {
      notifyWhenReady(terminationMessage);
    }

    dispatchLogoutEvent();
    return;
  }
  toaster(error.response.data.Message || 'Ooops, something went wrong');
};

export default errorHandler;
